module.exports = __webpack_public_path__ + "img/11G_1563435923.48680d4e.png";